export const avatarTexts = {
    header: 'How can I help you ?',
    subheader: 'Not sure where to start? Just ask TOMI.',
};

export const errorMessages = {
    general: 'Sorry, something went wrong:',
    websocketGeneral: 'Error from websocket.',
    websocketClosed: 'WebSocket closed unexpectedly.',
};

export const spherePoints = {
    firstSpherePointSize: 0.02,
    secondSpherePointSize: 0.015,
} as const;

export const audioConfig = {
    fftSize: 256,
    maxFrequencyValue: 255,
    smoothingFactor: 0.1,
} as const;
